<template>
	<div class="tc-player" ref="playref">
		<video :id="id" preload="auto" playsinline webkit-playsinline></video>
		<img v-if="playingError" :src="cover" class="cover" />
	</div>
</template>
<script>
import TCPlayer from "tcplayer.js";
import "tcplayer.js/dist/tcplayer.min.css";
import Vue from "vue"

export default {
	props: {
		id: {
			type: String,
			default: "vplayer",
		},
		url: {
			type: String,
			default: "",
		},
		cover: {
			type: String,
			default: "",
		},
		liveinfo:{
			type:Object,
			default:()=>{}
		},
		iswater:{
			type:Boolean,
			default:false
		},
		userinfo:{
			type:Object,
			default:()=>{}
		}
	},
	components: {},
	data() {
		return {
			player: null,
			playingError: false,
			watchedTime: 0,
			lastWatchTime: 0,
			lastReportTime: 0
		};
	},
	computed: {},
	watch: {
		url(newV, oldV) {
			// do something
			console.log("拉流地址改变", newV);
			if (newV) {
				this.url = newV;
				this.player.src({ src: newV, type: "video/mp4" });
			}
		},
		watchedTime() {
			if (parseInt(this.watchedTime - this.lastReportTime) === 1) {
				this.lastReportTime = this.watchedTime
				Vue.prototype.socketIo.emit('reportWatchedTime',{watchedTime: parseInt(this.watchedTime)})
			}
		},
		iswater(newV){
			var indexVue = window.indexVue
			var name = indexVue.userinfo.name?indexVue.userinfo.name:indexVue.userinfo.nick_name
			var text = name+String(indexVue.userinfo.mobile)
			if (newV) {
				this.player.DynamicWatermark({
					type: 'text',
					speed: 0.5,// 建议取值范围 0<= speed <=1，默认值 0.2
					content: text, // 类型必须为String，
					opacity: 0.8,
					fontSize: '12px', // type === text 时有效, 其余字段通用
					color: '#fff',
				})
			}
		},
		userinfo(newV){
			console.log('更新了userinfo')
			var indexVue = window.indexVue
			var name = indexVue.userinfo.name?indexVue.userinfo.name:indexVue.userinfo.nick_name
			var text = name+String(indexVue.userinfo.mobile)		
			if (newV && this.iswater) {
				console.log('水印文案：',text)
				this.player.DynamicWatermark({
					type: 'text',
					speed: 0.5,// 建议取值范围 0<= speed <=1，默认值 0.2
					content: text, // 类型必须为String，
					opacity: 0.8,
					fontSize: '12px', // type === text 时有效, 其余字段通用
					color: '#fff',
				})
			}
		}
	},
	mounted() {
		this.playerInit();
		
	},
	beforeDestroy() {
		this.playerDispose();
	},
	methods: {
		playerInit() {
			this.playerDispose();
			this.player = TCPlayer(this.id, {
				control: true,
				controlBar: { volumePanel: true, playbackRateMenuButton: true },
				live: true,
				autoplay: false,
				x5_player: true,
				x5_type: "h5-page",
				x5_fullscreen: true,
				poster:this.cover,
				licenseUrl:'https://license.vod2.myqcloud.com/license/v2/1307820426_1/v_cube.license',
			});
			// this.player.on("ready",(error) => {
			// 	console.log('readyhaole')
			// 	if(this.liveinfo.live_status == 2 && this.userinfo.sign_up != '1' && indexVue.liveinfo.is_real && indexVue.userinfo.has_input_pass == 1 && indexVue.liveinfo.encryption_status == 2){
			// 		this.player.pause();
			// 	}
			// })
			this.player.on("play", (error) => {
				console.log("tcplayer play", error);
			});
			this.player.on("canplay", (error) => {
				console.log("tcplayer canplay", error);
				this.playingError = false;
			});
			this.player.on("playing", (evt) => {
				console.log("tcplayer playing", evt);
				this.playingError = false;
			});

			this.player.on("error", (error) => {
				console.error("tcplayer error", error);
				// alert(error.data.code)
				this.playingError = true;
				this.replay(); // 重连
			});

			this.player.on('timeupdate', () => {
				const processTime = this.player.currentTime() - this.lastWatchTime
				if (processTime > 0 && processTime < 1) {
				this.watchedTime += this.player.currentTime() - this.lastWatchTime
				this.lastWatchTime =this.player.currentTime()
				}
			})
			this.player.on('seeked', () => {
				this.lastWatchTime = this.player.currentTime()
			})
			// this.player.on("fullscreenchange", (isFullscreen) => {
			// 	if (isFullscreen) {
			// 	// 进入全屏时，强制横屏
			// 	if (screen.orientation && screen.orientation.lock) {
			// 		screen.orientation.lock('landscape').catch(err => {
			// 		// alert('Failed to lock orientation:', err);
			// 		});
			// 	}else{
			// 		this.$toast({
			// 			message: `<div style="height:40px;display:flex;align-items:center;justified-content:center">请转为横屏播放</div>`,
			// 			type: 'html'
            // 		})
			// 	}
			// 	} else {
			// 	// 退出全屏时，恢复为默认方向
			// 		if (screen.orientation && screen.orientation.unlock) {
			// 			screen.orientation.unlock();
			// 		}
			// 	}
			// })
			// this.player.on("webrtcevent", (event) => {
			// 	console.error("webrtcevent event", event.data.code, event);
			// });
			
			// live_status 2进行中  3已结束 playback_status1有回放2没有回放
			// if(this.liveinfo.encryption_status!=2 && this.liveinfo.live_status == 2 && this.liveinfo.is_pushing == 1 ){//直播进行并且没有加密直接播放
			// 	this.player.muted(true);
			// 	this.player.play();
			// }

		},
		replay() {
			setTimeout(() => {
				console.log("replay --------------------");
				// this.player.src({ src: this.url, type: 'video/mp4' })
				if(this.liveinfo.live_status == 2 && (this.userinfo.sign_up != '1' && indexVue.liveinfo.is_real) || (indexVue.userinfo.has_input_pass == 1 && indexVue.liveinfo.encryption_status == 2)){
					console.log(9999990)
					this.player.pause();
					}else{
					this.player.play()
       			 }	
			}, 5000);
		},
		playerDispose() {
			if (this.player) {
				this.player.dispose();
			}
			this.player = null;
		},
		weaterMaskCanvasFn(params = {}){
			let len = params.len || params?.text?.length || 3; // 可通过此数值大小，控制相邻文字的间距。
			const canvas = document.createElement('canvas');
			let fontSize = params.fontSize || 14,
				height = 150;
			canvas.width = len * fontSize * 1.1; // 可根据实际效果，修改2.2值
			canvas.height = height + fontSize * 1.8;

			const context = canvas.getContext('2d');
			context.translate(0, canvas.height / 1.8);
			context.rotate(((params.rotate || -30) * Math.PI) / height);
			context.font = `${fontSize}px Vedana`;
			context.fillStyle = params.color || '#f0f';
			context.fillText(params.text, 10, canvas.height / 2 - 100);

			const div = document.createElement('div');
			div.style.pointerEvents = 'none';
			div.style.position = 'absolute';
			div.style.zIndex = '999999';
			div.style.left = '0';
			div.style.top = '0';
			div.style.opacity = params.opacity || 0.5;
			// div.style.width = '150%';
			// div.style.height = '150%';
			var width = this.$refs.playref.offsetWidth;
			var heights = this.$refs.playref.offsetHeight;
			div.style.width = width + 'px';
			div.style.height = heights + 'px';
			div.style.background = `url(${canvas.toDataURL('images/png')}) repeat left top`;
			var dom = document.querySelector('.tc-player');
			dom.appendChild(div);
		}
	},
};
</script>
<style lang="less" scoped>
@import "../../assets/styles/share.less";
.tcplayer {
	width: 100%;
	height: 100%;
}
.tc-player {
	width: 100%;
	height: 100%;
	position: relative;
	> .cover {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background: #000;
		z-index: 1000;
	}
}
</style>
<style>
.vjs-control-bar {
	font-size: 0.84em !important;
}
.vjs-button :before {
	font-size: 1.26em !important;
}
.vjs-playback-rate-value {
	font-size: 0.84em !important;
}


/* 以下是修改全屏样式   Fullscreen mode */
.video-js.vjs-fullscreen .vjs-control-bar,
.video-js:-webkit-full-screen .vjs-control-bar {
    font-size: .35rem !important;
	height: 2em;
}
.video-js.vjs-fullscreen .vjs-button :before,
.video-js:-webkit-full-screen .vjs-button :before {
    font-size: .35rem !important; 
	line-height: 2;
}

.video-js.vjs-fullscreen .vjs-time-control .vjs-duration-display,
.video-js:-webkit-full-screen .vjs-time-control .vjs-duration-display {
    font-size: .24rem!important;
	line-height: 2.8
}
.video-js.vjs-fullscreen .vjs-time-control .vjs-current-time-display,
.video-js:-webkit-full-screen .vjs-time-control .vjs-current-time-display{
	font-size: .24rem!important;
	line-height: 2.8
}
/* .video-js.vjs-fullscreens .vjs-current-time {
	line-height: 2.8;
}
.video-js.vjs-fullscreens .vjs-duration{
	line-height: 2.8;
} */
.video-js.vjs-fullscreen .vjs-progress-holder{
	height: .17em;
}
.video-js.vjs-fullscreen .vjs-play-progress:before{
	font-size: .5em;
}
.video-js.vjs-fullscreen .vjs-menu-button{
	font-size: .35rem ; 
}
.video-js.vjs-fullscreen .vjs-volume-panel{
	width: 3em;
}
.video-js.vjs-fullscreen .vjs-play-control{
	width: 3.5em;
}
.video-js.vjs-fullscreen  .vjs-time-divider{
	line-height: 1.8;
}
</style>
